import Head from "next/head";
import { make as PatchNotesPage } from "../../src/info/PatchNotesPage.bs";
const fs = require("fs");
const path = require("path");
import { allPatches } from "common/src/Config.ts";
import { render } from "common/src/Patch.bs.js";

export default function PatchNotes({ data, allPatches }) {
  return (
    <>
      <Head>
        <title>{`Patch Notes - ${render(data[0])} Tft Update`}</title>
      </Head>
      <PatchNotesPage data={data} allPatches={allPatches} />
    </>
  );
}

export async function getStaticProps() {
  const data = [];
  const patches = allPatches.filter((p) => {
    if (p > 10000) {
      return p !== 13250 && p % 10 == 0;
    } else {
      return p % 2 == 0;
    }
  });
  for (let patch of patches) {
    try {
      const patchStr = render(patch).split(".").join("-").replace("-0", "-");
      const d = fs.readFileSync(
        path.resolve(__dirname, `../../../src/info/${patchStr}.json`),
        "utf8"
      );
      data.push([patch, JSON.parse(d)]);
    } catch (err) {
      console.log("ERR", err);
    }
  }

  const d = data[0];
  return {
    props: { allPatches: patches, data: d },
    // revalidate: 3600,
  };
}
